// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "hls" + "." + "da0befae" + ".chunk.js";
};